import { render } from "./LoginCredentials.vue?vue&type=template&id=84c9ec40&scoped=true"
import script from "./LoginCredentials.vue?vue&type=script&lang=js"
export * from "./LoginCredentials.vue?vue&type=script&lang=js"

import "./LoginCredentials.vue?vue&type=style&index=0&id=84c9ec40&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c9ec40"]])

export default __exports__